import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { optimizeImage } from '../utilities/images';
import { trackPerformanceToNR } from '../utilities/tracking';

const OptimizedImageBackground = ({
	children = null,
	className = null,
	style = {},
	width
}) => {
	// Start with blank image src, because we never want to load the
	//   unoptimized image
	const [optimizedImage, setOptimizedImage] = useState({
		width: 0,
		src: ''
	});
	let optimizedStyle = style;
	let _original;
	let src;
	let pre;
	let post;

	// Extract the image URL from the background-image style
	if (style && style.backgroundImage) {
		const regEx = /(.*)url\("(.+)"\)(.*)/;
		const background = regEx.exec(style.backgroundImage);
		if (background && background.length >= 4) {
			[_original, pre, src, post] = background;

			const img = new Image();
			img.onload = () =>
				trackPerformanceToNR('ws-specials-image-container-starting');
			img.src = src;

			optimizedStyle = {
				...optimizedStyle,
				backgroundImage: optimizedImage.src
					? `${pre}url("${optimizedImage.src}")${post}`
					: `${pre}none${post}`
			};
		}
	}

	useEffect(() => {
		// Only load larger images if the width changes...never downgrade
		if (src && width > optimizedImage.width) {
			const optimizedImg = optimizeImage(src, width);
			setOptimizedImage(optimizedImg);
			if (src) {
				const img = new Image();
				img.onload = () =>
					trackPerformanceToNR('ws-specials-first-promo-img-load');
				img.src = optimizedImg.src;
			}
		}
	}, [src, width, optimizedImage.width]);

	return (
		<div className={className} style={optimizedStyle}>
			{children}
		</div>
	);
};

OptimizedImageBackground.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	style: PropTypes.shape({}),
	width: PropTypes.number.isRequired
};

export default OptimizedImageBackground;
